import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function() {
  const { t } = useTranslation('translation');
  let answer = t('threatIpError');
  let arrAnswer: string[] = answer.trim().split('. ');
  return (
    <Typography variant="body1" component={'span'}>
      {arrAnswer.map((item, index) => {
        return (
          <div
            style={{
              fontWeight: index === 0 ? 'bold' : 'inherit',
              textAlign: 'center'
            }}
          >
            {item}.
          </div>
        );
      })}
    </Typography>
  );
}
